import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isTokenExpired, clearAuthData } from "../utils/tokenUtils";
import { autoLogout } from "../redux/actions/common.action";

export const useAuthCheck = (enabled: boolean) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!enabled) return; // ⛔ Do nothing if disabled

    const checkToken = () => {
      if (isTokenExpired()) {
        console.log("Token expired - auto logging out");
        dispatch(autoLogout());
      }
    };

    // Initial check
    checkToken();

    // Periodic checks
    intervalRef.current = setInterval(checkToken, 60000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [enabled, dispatch, navigate]);
};
